import AMBEV_DOMAINS from '../../../../../common/constants/ambev-domains';
import CONTACT_SUPPORT_MESSAGE from '../../../../../common/constants/messages';
import { getAuthAxiosInstance } from '../../../../../common/services/axios-config';

const reproveUserRequest = async (userRequestId: string): Promise<boolean> => {
    const api = await getAuthAxiosInstance();

    try {
        await api.post(`v1/users-requests/${userRequestId}:reprove`);
        return true;
    } catch {
        throw new Error(CONTACT_SUPPORT_MESSAGE);
    }
};

const approveUserRequest = async (
    userRequestId: string,
    userType?: number,
): Promise<boolean> => {
    const api = await getAuthAxiosInstance();

    try {
        await api.post(`v1/users-requests/${userRequestId}:approve`, {
            userType,
        });
        return true;
    } catch {
        throw new Error(CONTACT_SUPPORT_MESSAGE);
    }
};

const isAmbevUser = (userEmail: string): boolean => {
    return AMBEV_DOMAINS.some(domain => userEmail.includes(domain));
};

export default (() => {
    return {
        reproveUserRequest,
        approveUserRequest,
        isAmbevUser,
    };
})();
